import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppHttpClientService, AppHttpClientConfig } from '../shared/app-http-client.service';
import { BidCutRequest, ApproveBidCutRequestPayload } from './hammer-bid-cut-request.model';
import { BID_CUT_REQUEST_CONFIG } from './hammer-bid-cut-request.config';

@Injectable({
  providedIn: 'root'
})
export class HammerBidCutRequestService {
  constructor(
    private readonly db: AngularFirestore,
    private readonly httpClient: AppHttpClientService
  ) {}

  listenForCutBidRequests(auctionId: string): Observable<BidCutRequest[]> {
    return this.db
      .collection(auctionId)
      .doc('sections')
      .collection<BidCutRequest>('cutBidRequests')
      .snapshotChanges()
      .pipe(
        map((actions: DocumentChangeAction<BidCutRequest>[]) => {
          return actions.map(action => {
            const data = action.payload.doc.data();
            const id = action.payload.doc.id;
            return { id, ...data } as BidCutRequest;
          });
        })
      );
  }

  async approveBidCutRequest(
    requestId: string,
    payload: ApproveBidCutRequestPayload
  ): Promise<void> {
    const config = new AppHttpClientConfig();
    config.maxRetries = BID_CUT_REQUEST_CONFIG.MAX_RETRIES;
    config.backoffMs = BID_CUT_REQUEST_CONFIG.BACKOFF_MS;

    return this.httpClient.put(
      `bids/cut/${requestId}/approve`,
      payload,
      config
    );
  }

  async rejectBidCutRequest(requestId: string, auctionId: string): Promise<void> {
    const config = new AppHttpClientConfig();
    config.maxRetries = BID_CUT_REQUEST_CONFIG.MAX_RETRIES;
    config.backoffMs = BID_CUT_REQUEST_CONFIG.BACKOFF_MS;

    return this.httpClient.put(
      `bids/cut/${requestId}/reject`,
      { auctionId },
      config
    );
  }
}

